import {ChangeDetectorRef, Component, OnInit} from '@angular/core';
import * as json from '../../../assets/mock/products.json';
import {Products} from '../../domain/main';
import {ActivatedRoute} from '@angular/router';
import {environment} from '../../../environments/environment';
@Component({
  selector: 'app-switches',
  templateUrl: './switches.component.html',
  styleUrls: ['./switches.component.less']
})
export class SwitchesComponent implements OnInit {
  public products = [];
  public product: Products;
  public loadedContent = false;
  public lg;
  public queryParams;
  public env = environment;
  constructor(private route: ActivatedRoute,
              private cdr: ChangeDetectorRef) {
  }
  ngOnInit() {
    this.products = JSON.parse(JSON.stringify(json.products));
    this.product = this.products[4];
    setTimeout( () => this.loadedContent = true , 500);
    this.route.queryParams.subscribe( () => {
      this.lg = this.env.lang;
      this.queryParams = this.env.queryParams;
      this.cdr.detectChanges();
    });
  }
}
